
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"27","viewBox":"0 0 32 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.2861 23.4775H1.71387C0.771325 23.4775 0 24.2698 0 25.2379C0 26.206 0.771325 27 1.71387 27H30.2861C31.2287 27 32 26.206 32 25.2379C32 24.2698 31.2287 23.4775 30.2861 23.4775ZM30.2861 11.7388H1.71387C0.771325 11.7388 0 12.531 0 13.4991C0 14.4673 0.771325 15.2612 1.71387 15.2612H30.2861C31.2287 15.2612 32 14.4673 32 13.4991C32 12.531 31.2287 11.7388 30.2861 11.7388ZM30.2861 0H1.71387C0.771325 0 0 0.79226 0 1.76039C0 2.72851 0.771325 3.52077 1.71387 3.52077H30.2861C31.2287 3.52077 32 2.72851 32 1.76209C32 0.792259 31.2287 0 30.2861 0V0Z","fill":"currentColor"}})])
          )
        }
      }
    